import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../PanelAssets/img/logo.png";
import { useEffect } from "react";

import AOS from "aos";
import "aos/dist/aos.css";
import FeatherIcon from "feather-icons-react";
import { avatar01 } from "../PanelImagepath";

import { isAuthenticated, logoutAndRedirect } from "../../commons/Auth/auth";

import { useTranslation } from "react-i18next";
const NormalUserHeader = () => {
  const { t } = useTranslation("dashboard");
  const user = isAuthenticated();
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true
    });
  }, []);

  const [isSideMenu, setSideMenu] = useState("");
  const [button, setButton] = useState(true);
  const [navbar, setNavbar] = useState(false);
  const toggleSidebar = value => {
    setSideMenu(value);
  };

  let pathnames = window.location.pathname;

  const url = pathnames.split("/").slice(0, -1).join("/");

  const onHandleMobileMenu = () => {
    var root = document.getElementsByTagName("html")[0];
    root.classList.add("menu-opened");
  };

  const onhandleCloseMenu = () => {
    var root = document.getElementsByTagName("html")[0];
    root.classList.remove("menu-opened");
  };

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);
  window.addEventListener("resize", showButton);

  const changeBackground = () => {
    if (window.scrollY >= 95) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };
  window.addEventListener("scroll", changeBackground);

  return (
    <>
      {!pathnames.includes("home1") && (
        <header className={"header-fixed header-one"}>
          <div className="container">
            <nav
              className={`navbar navbar-expand-lg header-nav ${
                pathnames.includes("home1") ? "nav-transparent" : ""
              }`}
            >
              <div className="navbar-header">
                <Link to="#0" id="mobile_btn" onClick={() => onHandleMobileMenu()}>
                  <span className="bar-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                </Link>
                <Link to="/" className="navbar-brand logo">
                  <img src={logo} style={{ width: "160px" }} className="img-fluid" alt="Logo" />
                </Link>
              </div>
              <div className="main-menu-wrapper">
                <div className="menu-header">
                  <Link to="/" className="menu-logo">
                    <img src={logo} className="img-fluid" alt="Logo" />
                  </Link>
                  <Link
                    to="#0"
                    id="menu_close"
                    className="menu-close"
                    onClick={() => onhandleCloseMenu()}
                  >
                    <i className="fas fa-times"></i>
                  </Link>
                </div>

                <ul className={`main-nav ${pathnames.includes("home4") ? "white-font" : ""}`}>
                  <li className="has-submenu">
                    <Link
                      to="#"
                      className={isSideMenu == "admin" ? "subdrop" : ""}
                      onMouseEnter={() =>
                        toggleSidebar(isSideMenu == "admin" ? "submenu" : "admin")
                      }
                    >
                      {t("Roles")}
                      <i className="fas fa-chevron-down" />
                    </Link>
                    {isSideMenu == "admin" ? (
                      <ul className={`${isSideMenu == "admin" ? "submenu d-block" : "submenu"}`}>
                        <li>
                          <Link to="/admin" target="_blank">
                            {t("Admin")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/subadmin" target="_blank">
                            {t("Sub Admin")}
                          </Link>
                        </li>
                        <li>
                          <Link to="/login" target="_blank">
                            {t("Service Provider")}
                          </Link>
                        </li>
                        <li>
                          <Link to="/user" target="_blank">
                            {t("Employees")}
                          </Link>
                        </li>
                      </ul>
                    ) : (
                      ""
                    )}
                  </li>
                  {user && user?.role === 0 ? (
                    <li className="has-submenu">
                      <Link to="#" className={"user"} onMouseEnter={() => toggleSidebar("user")}>
                        <span className="user-img">
                          <img
                            className="rounded-circle"
                            src={user?.picture ? user?.picture?.url : avatar01}
                            style={{ width: "32px", height: "32px" }}
                            alt="Ryan Taylor"
                          />
                        </span>
                        <i className="fas fa-chevron-down" />
                      </Link>
                      {isSideMenu == "user" && (
                        <ul
                          className={`p-2 ${isSideMenu == "user" ? "submenu d-block" : "submenu"}`}
                        >
                          <div className="user-header">
                            <div className="avatar avatar-sm">
                              <img
                                src={user?.picture ? user?.picture?.url : avatar01}
                                alt="User Image"
                                className="avatar-img rounded-circle"
                              />
                            </div>
                            <div className="user-text">
                              <h6>
                                {user?.firstName} {user?.lastName}
                              </h6>
                              <p className="text-muted mb-0">{t("User")}</p>
                            </div>
                          </div>
                          <Link className="dropdown-item" to={`/user/profile-setting`}>
                            {t("My Profile")}
                          </Link>
                          <a
                            className="dropdown-item"
                            href={`#`}
                            onClick={e => {
                              e.preventDefault();
                              logoutAndRedirect();
                            }}
                          >
                            {t("Logout")}
                          </a>
                        </ul>
                      )}
                    </li>
                  ) : (
                    <>
                      {/* <li className="register-btn">
                                                    <Link to="/register" className="btn reg-btn">
                                                        <i>
                                                            <FeatherIcon icon="user" />
                                                        </i>
                                                        {t("Register")}
                                                    </Link>
                                                </li> */}
                      <li className="register-btn">
                        <Link to="/login" className="btn btn-primary log-btn">
                          <i>
                            <FeatherIcon icon="lock" />
                          </i>
                          {t("Login")}
                        </Link>
                      </li>
                    </>
                  )}
                </ul>
              </div>
            </nav>
          </div>
        </header>
      )}
    </>
  );
};

export default NormalUserHeader;
